<template>
  <div class="sw-step-navigation d-flex justify-content-between text-center">
    <div
      v-for="step in navigationSteps"
      :key="step.id"
      :class="checkStepNavigationStatus(step.id, currentStep)"
      @click="$emit('stepIdClick', step.id)"
    >
      <div
        class="sw-step-navigation-id d-flex justify-content-center align-items-center rounded-circle mx-auto font-weight-bold mb-3"
      >
        <span>{{step.id}}</span>
      </div>
      <div class="sw-step-navigation-description">
        <strong>{{step.label}}</strong>
        <p>
          <small>{{computeStepNavigationDescription(step, currentStep, descriptionIndex)}}</small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navigationSteps: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: Number,
      default: 1
    },
    descriptionIndex: {
      type: Number,
      default: 0
    },
    validSteps: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {},
  methods: {
    checkStepNavigationStatus(stepId, currentStep) {
      let status = 'sw-step-navigation-item';

      if (stepId === currentStep) {
        status += ' current';
      }

      if (stepId < currentStep) {
        status += ' finished';
      }

      if (this.validSteps[stepId]) {
        status += ' pointer';
      }


      return status;
    },
    computeStepNavigationDescription(step, currentStep, descriptionIndex) {
      const { id, description, finishDescription } = step;
      const status = this.checkStepNavigationStatus(id, currentStep);
      let desc = '';

      if (!description) {
        return '';
      }

      switch (status) {
        case 'current':
          desc = description[descriptionIndex];
          break;
        case 'finished':
          desc = finishDescription;
          break;
        default:
          return '';
      }

      return desc;
    }
  },
};
</script>

<style lang="scss">
  $black: black;
  $app-gray: gray;
  $gray-700: light-gray;
  $orange: orange;
  $green: green;
  $solid: solid;
  $white: white;

  // .sw-step-navigation::before {
  //   content: '';
  //   position: absolute;
  //   top: 25px;
  //   left: 0;
  //   display: block;
  //   height: 1px;
  //   width: 100%;
  //   background: transparent;
  //   border-bottom: 1px dashed $black;
  // }

  .sw-step-navigation,
  .sw-step-navigation-item,
  .sw-step-navigation-description {
    position: relative;
  }

  .sw-step-navigation-item {

    &:first-child,
    &:last-child {
      &::before {
        content: '';
        position: absolute;
        top: 0;
        display: block;
        height: 100%;
        width: 50%;
        // background: $app-gray;
      }
    }

    &:first-child::before {
      left: 0;
    }

    &:last-child::before {
      right: 0;
    }
  }

  .sw-step-navigation-id {
    width: 50px;
    height: 50px;
    border: 1px solid #b9b3b3;
    color: $gray-700;
    position: relative;
    background: $white;
  }

  .sw-step-navigation-item.current {
    .sw-step-navigation-id {
      border-color: $orange;
      color: $orange;
    }

    .sw-step-navigation-description {
      color: $orange;

      small, strong {
        color: $orange;
      }
    }
  }

  .sw-step-navigation-item.finished {
    .sw-step-navigation-id {
      span {
        display: none;
      }

      border-color: $green;
      background: $green;

      &::after {
        content: "";
        background-color: transparent;
        position: absolute;
        left: 0;
        top: 50%;
        right: 0;
        margin: -12px auto auto auto;
        width: 13px;
        height: 14px;
        border-bottom: 2px solid $white;
        height: 20px;
        border-right: 2px solid $white;
        transform: rotate(45deg);
      }
    }

    .sw-step-navigation-description {
      color: $green;

      small, strong {
        color: $green;
      }
    }
  }
</style>
